export const color_palette = ["#FEF5ED", "#D3E4CD", "#FFC4E1", "#D7E9F7", "#F0D9FF", "#F5E8C7"];
export const random_color_from_palette = color_palette[Math.floor(Math.random() * color_palette.length)];
export const returnRandomColor = (color_arr: any) => {
    return color_arr[Math.floor(Math.random() * color_palette.length)];
};
